import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import VueGtag from "vue-gtag";

Vue.config.productionTip = false


Vue.use(VueGtag, {
    config: {
        id: "UA-167736521-1",
        appName: 'Borgle',
        pageTrackerScreenviewEnabled: true
    }
}, router);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
